import type { Announcements } from "@dnd-kit/core";
import type useDragAnnouncementLabels from "./useDragAnnouncementLabels";

type DragAnnouncementLabels = ReturnType<typeof useDragAnnouncementLabels>;

/**
 * Composes localized drag-announcement strings into a dnd-kit `Announcements`
 * object. The consumer supplies a `getItemLabel` function that takes an
 * item id to map to a localized label.
 */
const createDragAnnouncements = (
  labels: DragAnnouncementLabels,
  getItemLabel: (id: string) => string
): Announcements => ({
  onDragStart: ({ active }) =>
    labels.dragPickedUp(getItemLabel(String(active.id))),
  onDragOver: ({ active, over }) =>
    over
      ? labels.dragMoving(
          getItemLabel(String(active.id)),
          getItemLabel(String(over.id))
        )
      : undefined,
  onDragEnd: ({ active, over }) =>
    over
      ? labels.dragDroppedOn(
          getItemLabel(String(active.id)),
          getItemLabel(String(over.id))
        )
      : labels.dragDropped(getItemLabel(String(active.id))),
  onDragCancel: ({ active }) =>
    labels.dragCancelled(getItemLabel(String(active.id))),
});

export default createDragAnnouncements;
